import { c as _c } from "react/compiler-runtime";
import type { Color } from '@onefootprint/design-tokens';
import { IcoMapPinDefault, IcoMapPinSelected } from '@onefootprint/icons';
import { useTheme } from 'next-themes';
import type { JSX } from 'react';
export type MapMarkerProps = {
  id: string;
  lat: number;
  lng: number;
  isSelected?: boolean;
  getIcon: (color?: Color) => JSX.Element;
  onClick?: (id: string, lat: number, lng: number) => void;
};
const MapMarker = t0 => {
  const $ = _c(19);
  const {
    id,
    onClick,
    lat,
    lng,
    isSelected,
    getIcon
  } = t0;
  const theme = useTheme();
  const isDark = theme.theme === "dark";
  const iconColorDefault = isDark ? "tertiary" : "primary";
  const iconColorSelected = isDark ? "primary" : "quinary";
  let t1;
  if ($[0] !== id || $[1] !== lat || $[2] !== lng || $[3] !== onClick) {
    t1 = () => onClick?.(id, lat, lng);
    $[0] = id;
    $[1] = lat;
    $[2] = lng;
    $[3] = onClick;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isSelected) {
    t2 = <div className="flex justify-center items-center [&>svg]:overflow-visible [&>svg>path]:drop-shadow-[0px_1px_12px_rgba(5,5,5,0.18)]">{isSelected ? <IcoMapPinSelected /> : <IcoMapPinDefault />}</div>;
    $[5] = isSelected;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = isSelected ? iconColorSelected : iconColorDefault;
  let t4;
  if ($[7] !== getIcon || $[8] !== t3) {
    t4 = getIcon(t3);
    $[7] = getIcon;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <div className="flex justify-center items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[90%]">{t4}</div>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== id || $[13] !== lat || $[14] !== lng || $[15] !== t1 || $[16] !== t2 || $[17] !== t5) {
    t6 = <button className="relative flex items-center justify-center cursor-pointer" id={id} type="button" onClick={t1} data-lat={lat} data-lng={lng}>{t2}{t5}</button>;
    $[12] = id;
    $[13] = lat;
    $[14] = lng;
    $[15] = t1;
    $[16] = t2;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export default MapMarker;